/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
const JobcardActivity = ({
    field: { name },
    form: { setFieldValue },
    typeName,
    ...props
}) => {
    const [jobcardsActivityOptions, setjJobcardsActivityOptions] = useState([])

    useEffect(() => {
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                customerNo: customerNo,
                customerNumber: customerNo,
                userId: userId,
                jobcardTypeId: props.typeJobcardActivity
            })
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCardActivity`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        }).then((response => {
            let data = response.data.data;
            let tempArr = [];
            data.forEach(element => {
                let temp = {};
                temp.key = element.jobcardActivityId
                if (element.jobcardActivityName.indexOf('Add ') != -1) {
                    temp.text = 'Add'
                }
                else if (element.jobcardActivityName.indexOf('Remove ') != -1) {
                    temp.text = 'Remove'
                }
                else if (element.jobcardActivityName.indexOf('Replace ') != -1) {
                    temp.text = 'Replace'
                }
                temp.value = element.jobcardActivityId
                tempArr.push(temp)
            });

            setjJobcardsActivityOptions(tempArr)
        }))
            .catch(error => console.log(error))
    }, [props?.typeJobcardActivity])

    return (
        <Dropdown
            selection
            clearable
            placeholder="Jobcard Activity"
            onChange={(value, data) => {
                setFieldValue(name, data.value)
            }}
            options={jobcardsActivityOptions}
            {...props}
        />

    )
}

export default JobcardActivity